// extracted by mini-css-extract-plugin
module.exports = {"slide":"DetailOrders_slide_33Njd","slide-reverse":"DetailOrders_slide-reverse_3oQi3","header":"DetailOrders_header_1Q2N7","component":"DetailOrders_component_2BT5i"};